export var SessionStorageKeys;
(function (SessionStorageKeys) {
    SessionStorageKeys["SEND_NOW_SCHEDULER_FILTERS"] = "sendNowSchedulerFilters";
    SessionStorageKeys["SEND_NOW_SCHEDULER_PARAMETERS"] = "sendNowSchedulerParameters";
})(SessionStorageKeys || (SessionStorageKeys = {}));
//# sourceMappingURL=sessionStorageKeys.js.map